var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('messages',{attrs:{"data-src":_vm.messages,"base-class":"job-messages"},scopedSlots:_vm._u([{key:"message",fn:function(ref){
var message = ref.message;
return [_c('job-message',{attrs:{"message":message,"base-class":"job-messages__message"}})]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }